import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "./firebase";

// Get Firebase Functions instance
const functions = getFunctions(app);

// Create a callable function reference for the Gemini API proxy
const generateContentCallable = httpsCallable(functions, 'generateContent');

/**
 * Client-side adapter for the Gemini API Cloud Function
 * @param prompt The prompt to send to the Gemini API
 * @param modelName Optional model name (defaults to 'gemini-2.0-flash' on the server)
 * @param skipCommandDetection Skip SEO/Writing command detection for agent-generated content
 * @returns The generated text from Gemini API
 */
export const callGeminiAPI = async (prompt: string, modelName?: string, skipCommandDetection?: boolean): Promise<string> => {
  try {
    const result = await generateContentCallable({
      prompt,
      modelName,
      skipCommandDetection
    });
    
    // The response data is nested in a 'data' property
    const response = result.data as { text: string; success: boolean };
    
    if (response.success) {
      return response.text;
    } else {
      throw new Error('Failed to generate content');
    }
  } catch (error: any) {
    console.error('Error calling Gemini API:', error);
    const errorMessage = error.message || 'Unknown error calling Gemini API';
    throw new Error(errorMessage);
  }
};
